var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3DC19DDE-449F-4C91-BDFE-21C680AF88A3@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KP_Contribution_Case-number-suggestion",
    transform: "translate(-857.000000, -1408.000000)",
    fill: "#B7B7B7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy-13",
    transform: "translate(697.000000, 1404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_delete_1832000_000000-copy",
    transform: "translate(160.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92543683,7.92543683 C4.02485439,11.8260193 4.02485439,18.1739807 7.92543683,22.0745632 C11.8260193,25.9751456 18.1739807,25.9751456 22.0745632,22.0745632 C25.9751456,18.1739807 25.9751456,11.8260193 22.0745632,7.92543683 C18.1739807,4.02485439 11.8269419,4.02485439 7.92543683,7.92543683 Z M19.2417392,11.9016781 L16.3053457,14.8373796 L19.2410472,17.7730811 C19.646514,18.1785479 19.646514,18.8354189 19.2410472,19.2408858 C18.8355804,19.6463526 18.1787094,19.6463526 17.7732426,19.2408858 L14.8375411,16.3051842 L11.9018396,19.2415778 C11.4963728,19.6470446 10.8395018,19.6470446 10.4340349,19.2415778 C10.0285681,18.836111 10.0285681,18.17924 10.4340349,17.7737731 L13.3697365,14.8380716 L10.4333429,11.9016781 C10.0278761,11.4962113 10.0278761,10.8393403 10.4333429,10.4338735 C10.8388098,10.0284067 11.4956808,10.0284067 11.9011476,10.4338735 L14.8368491,13.369575 L17.7725506,10.4338735 C18.1780174,10.0284067 18.8348884,10.0284067 19.2403552,10.4338735 C19.6467216,10.8384407 19.6467216,11.4962113 19.2421574,11.9016781 L19.2417392,11.9016781 Z",
    id: "Shape",
    transform: "translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusicon);
export default __webpack_public_path__ + "static/media/plusicon.10121b95de6f414b032deccc22899ca5.svg";
export { ForwardRef as ReactComponent };